import { Box } from '@mui/material';
import { brand } from 'src/shared/branding/brand';
import { REBRAND_PORTAL_URL, rebrandBannerCopy } from 'src/shared/branding/rebrandBanner';

export const RebrandBanner = () => {
  const copy = rebrandBannerCopy(new Date(), brand.key);
  if (!copy) return null;

  return (
    <Box
      role="status"
      sx={{
        background: '#FEF9DA',
        color: '#1A1F36',
        fontSize: '14px',
        lineHeight: 1.45,
        padding: '12px 20px',
        textAlign: 'center',
      }}
    >
      {copy}{' '}
      <a href={REBRAND_PORTAL_URL} style={{ color: '#635BFF', fontWeight: 600 }}>
        pay.billroute.com
      </a>
    </Box>
  );
};
